import React from "react";
import { useLang } from "@/context/LanguageContext";
import { useSeo, useJsonLd } from "@/lib/api";
import { Section, Reveal, Eyebrow } from "@/components/common/Section";
import Breadcrumb from "@/components/common/Breadcrumb";
import FaqAccordion from "@/components/common/FaqAccordion";
import FinalCta from "@/components/common/FinalCta";

export default function Faq() {
  const { t, lang } = useLang();
  useSeo({ lang, path: "/faq", title: `${t.footer.links.faq.label} — NEKASSUR`, description: t.faq.title });
  useJsonLd("ld-faq", {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: t.faq.items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  });

  return (
    <>
      <section className="bg-nek-navy">
        <div className="nek-container py-12 sm:py-16">
          <Breadcrumb onDark items={[{ label: t.footer.links.faq.label }]} />
          <Reveal className="mt-8 max-w-3xl">
            <Eyebrow className="!text-nek-teal-100">{t.faq.eyebrow}</Eyebrow>
            <h1 className="nek-h1 mt-4 text-white" style={{ fontSize: "clamp(2.2rem,4vw,3.4rem)" }}>{t.faq.title}</h1>
          </Reveal>
        </div>
      </section>
      <Section tone="white">
        <FaqAccordion items={t.faq.items} testidPrefix="page-faq" />
      </Section>
      <FinalCta />
    </>
  );
}
